export default [
  {
    text: 'Start',
    value: 'start_date',
    width: '10%',
    sortable: false,
  },
  {
    text: 'End',
    value: 'end_date',
    width: '10%',
    sortable: false,
  },
  {
    text: 'Deal',
    value: 'deal',
    sortable: false,
  },
  {
    text: 'Page',
    value: 'page',
    width: '10%',
    sortable: false,
  },
  {
    text: 'Status',
    value: 'status',
    width: '10%',
    sortable: false,
  },
];
